import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const CheckmarkCircle = (param)=>{
    let { size = 24, testId, style, className } = param;
    const strokeWidth = 1.5 * (24 / size);
    return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z",
                stroke: "currentColor",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.75 12L10.58 14.83L16.25 9.17",
                stroke: "currentColor",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
